import React from 'react';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { TableSearch } from 'components/Tables';

export default function Header({
  value = '',
  placeholder = '',
  onSearch = () => {},
  buttonText = '',
  isDisabled = false,
  onButtonClick = () => {}
}) {
  return (
    <div className={styles.row}>
      <TableSearch
        value={value}
        disabled={isDisabled}
        placeholder={placeholder}
        onChange={onSearch}
        onCancel={() => onSearch('')}
      />
      <UiKit.Button
        variant="secondary"
        onClick={onButtonClick}
        disabled={isDisabled}
      >
        {buttonText}
      </UiKit.Button>
    </div>
  );
}
